module.exports = __webpack_public_path__ + "static/media/anker-logo.f91b7a63.png";